
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reglement-cocoon",
      function () {
        return require("private-next-pages/reglement-cocoon.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reglement-cocoon"])
      });
    }
  